export default __webpack_public_path__ + "static/media/microbes_light.d68759a7.jpeg";